import { IKnmPlanFilter } from '../interfaces/IKnmPlanFilter';

export const initialPlanListFilter: IKnmPlanFilter = {
  name: '',
  knoIds: [],
  prosecutorOrganizationErvkUuids: [],
  types: [],
  isOnlyMine: false,
  childProsecutorOrgIncluded: false,
  childKnoIncluded: false,
  ignoreKno: false,
  isOnlyDeleted: false,
  statuses: [],
  erknmStatuses: [],
  id: null,
  startDate: '',
  endDate: '',
  isDefault: false,
};
